var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.copyContainerRefName,staticClass:"input-copy-container",style:({
    'padding-right': `${_vm.inputHeight}px`,
  })},[_vm._t("default"),_vm._v(" "),_c('div',{ref:_vm.copyRefName,staticClass:"input-copy",style:({
      bottom: `${_vm.bottom}px`,
      height: `${_vm.inputHeight}px`,
    })},[_c('woot-button',{attrs:{"variant":"smooth","color-scheme":"secondary","icon":_vm.isCopied ? 'clipboard-task' : 'duplicate'},on:{"click":_vm.copyToClipboard}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }